<template>
  <div
    class="tw-flex tw-items-center tw-justify-center tw-transition-all tw-rounded-full tw-px-2.5 tw-py-1 tw-text-sm tw-leading-none tw-cursor-pointer focus:tw-outline-primary-100 tw-border-2 tw-text-primary tw-border-primary tw-bg-primary-100 hover:tw-border-neutral-900 hover:tw-text-neutral-900"
  >
    <div
      class="tw-flex tw-text-sm tw-items-center tw-gap-2 tw-font-semibold"
    >
      <slot />
    </div>
  </div>
</template>
